import type { ReactNode } from "react";
import { useLocation } from "react-router";
import { useGruppe } from "../gruppen";
import { pfadGehoertZu } from "../navigation";
import seiten from "../seiten/seiten.module.css";
import { Reiter, ReiterInhalt } from "./Reiter";

/** Seite einer Gruppe der Navigation, zum Beispiel „Sitzungen“ mit Nächste, Termine und Protokolle (BAUPLAN-PAKETE.md, Abschnitt 5.2):
 *  Überschrift der Gruppe, Reiter für alle Seiten, die die Person öffnen darf, darunter der Inhalt der aktuellen. Jede Seite behält
 *  ihre Adresse (Links in Mails). Mit nur einer erlaubten Seite gibt es keine Reiter. */
export function GruppenSeite({ gruppe, text, aktionen, children }: { gruppe: string; text?: ReactNode; aktionen?: ReactNode; children: ReactNode }) {
  const reiter = useGruppe(gruppe);
  const { pathname } = useLocation();
  const aktiv = reiter.find((r) => pfadGehoertZu(pathname, r.pfad))?.pfad;
  const panel = `gruppe-${gruppe.toLowerCase().replace(/[^a-z0-9]/g, "")}`;
  return (
    <div className={seiten.stapel}>
      <div className={seiten.kopf}>
        <div>
          <h1>{gruppe}.</h1>
          {text ? <p>{text}</p> : null}
        </div>
        {aktionen}
      </div>
      {reiter.length > 1 && aktiv ? (
        <>
          <Reiter label={gruppe} eintraege={reiter.map((r) => ({ id: r.pfad, label: r.label, pfad: r.pfad }))} aktiv={aktiv} panel={panel} />
          <ReiterInhalt panel={panel} aktiv={aktiv} className={seiten.stapel}>
            {children}
          </ReiterInhalt>
        </>
      ) : (
        <div className={seiten.stapel}>{children}</div>
      )}
    </div>
  );
}
